<template>
    <div class="detail-form" v-form="name" >
        <div class="left">
            <div class="front-form-item">
                <div class="item-title must">
                    <span>任务类型：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ $func.queryTaskTpl(detailData.template_id).tpl_name }}</div>
                    <el-select v-else v-model="sub.tempId" v-tar="sub.tempId" rule="choose" v-arg="['任务类型']" @change="linkage">
                        <el-option v-for="item in taskTpl_canChoose" :key="item.id" :label="item.tpl_name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>

            <div class="front-form-item" v-if="only_read">
                <div class="item-title">
                    <span>发布BU：</span>
                </div>
                <div class="item-wrap">
                    <div class="text">{{ detailData.pub_bu_name }}</div>
                </div>
            </div>

            <div class="front-form-item">
                <div class="item-title must">
                    <span>指定BU：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ detailData.sub_bu_name }}</div>
                    <!-- <el-select v-else v-model="sub.buId" v-tar="sub.buId" rule="choose" v-arg="['指定BU']">
                        <el-option v-for="item in bu_list" :key="item.id" :title="item.bu_name" :label="item.bu_name | titleLimit" :value="item.id"></el-option>
                    </el-select> -->
                    <el-select v-else v-model="sub.buId" v-tar="sub.buId" rule="choose" v-arg="['指定BU']">
                        <z-limitOption v-for="item in bu_list" :key="item.id" :label="item.bu_name" :value="item.id"></z-limitOption>
                    </el-select>
                </div>
            </div>

            <div class="front-form-item">
                <div class="item-title must">
                    <span>任务名称：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ detailData.task_name }}</div>
                    <el-input v-else v-model.trim="sub.taskName" v-tar.trim="sub.taskName" :maxlength="30" rule="noVal"></el-input>
                </div>
            </div>

            <div class="front-form-item">
                <div class="item-title">
                    <span>任务描述：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ detailData.task_description }}</div>
                    <el-input v-else type="textarea" v-model="sub.taskDescribe"></el-input>
                </div>
            </div>

            <div class="front-form-item">
                <div class="item-title">
                    <span>任务类型说明：</span>
                </div>
                <div class="item-wrap">
                    <div class="text type-text">{{ tpl_describe }}</div>
                </div>
            </div>

            <div class="front-form-item" v-if="task_id != 0">
                <div class="item-title">
                    <span>任务状态：</span>
                </div>
                <div class="item-wrap">
                    <div class="text">{{ status_str }}</div>
                </div>
            </div>

            <div class="front-form-item" v-if="detailData.process_status == 103">
                <div class="item-title">
                    <span>审核说明：</span>
                </div>
                <div class="item-wrap">
                    <div class="text reduce">{{ detailData.fail_result }}</div>
                </div>
            </div>

        </div>

        <!-- 右半边 -->
        <div class="right">

            <div class="front-form-item">
                <div class="item-title must">
                    <span>任务时长：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ detailData.task_cycle && detailData.task_cycle + "个工作日" }}</div>
                    <el-input v-else v-model.trim="sub.taskCycle" v-tar.trim="sub.taskCycle" rule="integer range" v-arg="[time_range,'任务时长']">
                        <template slot="append">工作日</template>
                    </el-input>
                    <transition name="fade">
                        <div class="tip" v-show="time_range.length">范围：{{ `${time_range[0]}-${time_range[1]}工作日` }}</div>
                    </transition>
                    
                </div>
            </div>

            <!-- <div class="front-form-item">
                <div class="item-title must">
                    <span>快币类型：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ $func.queryCurrency(detailData.currency_id).currency_name }}</div>
                    <el-select v-else v-model="sub.currencyId" v-tar="sub.currencyId" rule="choose" v-arg="['快币类型']">
                        <el-option v-for="item in currency_list" :key="item.id" :label="item.currency_name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div> -->

            <div class="front-form-item">
                <div class="item-title must">
                    <span>任务奖金：</span>
                </div>
                <div class="item-wrap">
                    <div class="text" v-if="only_read">{{ detailData.currency_amount && detailData.currency_amount + "币" }}</div>
                    <el-input v-else v-model.trim="sub.fastBonus" v-tar.trim="sub.fastBonus" rule="integer range" v-arg="[bonus_range,'任务奖金']">
                        <template slot="append">{{ task_curr.currency_name }}</template>
                    </el-input>
                    <transition name="fade">
                        <div class="tip" v-show="bonus_range.length">范围：{{ `${bonus_range[0]}-${bonus_range[1]}币` }}</div>
                    </transition>
                </div>
            </div>

            <div class="front-form-item" v-if='only_read'>
                <div class="item-title">
                    <span>发布人：</span>
                </div>
                <div class="item-wrap">
                    <div class='text'>{{ detailData.pub_user_name }}</div>
                </div>
            </div>

            <div class="front-form-item" v-if='only_read'>
                <div class="item-title">
                    <span>接收人：</span>
                </div>
                <div class="item-wrap">
                    <div class='text'>{{ detailData.sub_user_name || '暂无' }}</div>
                </div>
            </div>

            <div class="front-form-item" v-if="execute_judge" id="executor">
                <div class="item-title">
                    <span>执行人：</span>
                </div>
                <div class="item-wrap">
                    <el-select ref="select_dom" v-if="detailData.process_status == 201" v-model="sub.person" v-tar="sub.person" rule="choose" v-arg="['执行人']" @visible-change="hideChange">
                        <el-option v-for="item in bu_users" :key="item.id" :label="item.real_name" :value="item.id"></el-option>
                    </el-select>
                    <div v-else-if="assign_judge">
                        <el-select  v-model="assign_id">
                            <el-option v-for="item in bu_users" :key="item.id" :label="item.real_name" :value="item.id"></el-option>
                        </el-select>
                        <div class="front-btn blue" @click="changeAssign" :class="{disabled:!assign_id || assign_id == (detailData.assign_user && detailData.assign_user.assign_to)}">变更</div>
                    </div>
                    <div v-else class="text">{{ detailData.assign_user && detailData.assign_user.real_name }}</div>
                </div>
            </div>

            <div class="front-form-item" v-if="!only_read">
                <div class="item-title" :class="{must:data.tpl_doc_require == 1}">
                    <span>文件上传：</span>
                </div>
                <div class="item-wrap doc-wrap">
                    <div class="front-btn">
                        <span>选择文件</span>
                        <input type="file" multiple @change="addUploadFile($event)">
                    </div>
                    <span class="down-doctpl" @click="$emit('openDoc')">模板下载</span>
                    <z-scrollDiv class="box" ref="box" v-tar="sub.uploadDoc" v-arg="'上传文件'" :rule="upload_rule">
                        <div class="box-item" v-for="(item,index) in sub.uploadDoc" :key="item.name">
                            <span class="overhide" :title="item.name">{{ item.name }}</span>
                            <span class="red" @click="sub.uploadDoc.splice(index,1)">移除</span>
                        </div>
                        <div class="box-item" v-for="(item,index) in sub.require_doc" :key="item.id">
                            <span class="overhide" :title="item.doc_name">{{ item.doc_name }}</span>
                            <a class="blue" @click='downloadFile(item.id)'>下载</a>
                            <span class="red" @click="addDeleteId(item.id,index)">移除</span>
                        </div>
                     
                    </z-scrollDiv>
                </div>
            </div>

        </div>

        <!-- <div class="btns" v-if="!only_read">
            <div class="front-btn green" @click="save">保存</div>
            <div class="front-btn green" @click="release">发布</div>
        </div> -->

    </div>
</template>

<script>
    import { mapState,mapGetters } from "vuex"

    export default {

        props:["name","taskId","read","detailData",'sub',"hide"],
        data(){
            return {
                data:{},  //change 任务类型 获得的数据
                assign_id:"",  // 重指派执行人的id

                select_flag:false,  //是否有select选单展开
            }
        },
        computed:{
            ...mapState({
                buInfo:"buInfo",
                bu_users:"bu_users",
                status_obj:function(state){
                    let data = this.detailData;
                    let code;
                    if(this.buInfo.id == undefined || data.pub_bu_id == undefined){
                        return {};
                    }
                    if(this.buInfo.id == data.pub_bu_id){
                        code = 1;
                    }else if (this.buInfo.id == data.sub_bu_id){
                        code = 2;
                    }else if (this.$route.path.indexOf("backstage")!== -1){
                        code = 3;
                    }
                    return code ? state.task.task_status[data.category_status][code] : {};
                },
            }),
            ...mapGetters(["task_curr"]),
            only_read(){  //只读判断
                let data = this.detailData;
                let status = data.category_status;
                let process = data.process_status;
                return this.task_id != 0 && (this.read || status != 10);
            },
            assign_judge(){   //可调整执行人
                let  data = this.detailData || {};
                let status = data.category_status;
                let process = data.process_status;

                let arr = [
                    status == 20 && process == 203,   //执行中,
                ];

                return this.buInfo.id == data.sub_bu_id && arr.some(val=>val);
            },
            execute_judge(){  //执行人 可视判断
                let  data = this.detailData || {};
                let status = data.category_status;
                let process = data.process_status;

                let arr = [
                    this.buInfo.id == data.sub_bu_id && process == 201,   //待接收,
                    status == 20 && process == 203,   //执行中,
                    status == 20 && process == 204,   //验收中,
                    status == 20 && process == 205,   //取消中
                    status == 20 && process == 206,   //取消中(管理员)
                    status == 30 && process == 302,    //任务完成
                    status == 30 && process == 301,    //任务取消
                ];

                return arr.some(val=>val);
            },
            task_id(){   //任务id
                let str = this.$route.params.task_id;
                return this.taskId != undefined? this.taskId : this.$crypto.decrypt(str);
            },
            upload_rule(){  //上传文件列表 检查规则
                return this.data.tpl_doc_require == 1 && this.sub.require_doc.length == 0 ?"noVal":"";
            },

            // ****表单相关
            taskTpl_canChoose(){   //可以发布的任务类型   *******实现方式可能有误 数据更新未必能及时响应
                let id = this.buInfo.id;
                return id?this.buInfo.pub_template_ids.split(",").filter(item=>item!='').map(id=>{
                    return this.$func.queryTaskTpl(id);
                }):[];
            },
            bu_list(){  //可选的bu  
                let list = this.data.bu_list;
                return list ? list.filter(item=>{
                    return item.id != this.buInfo.id;
                }) : [];
            },  
            currency_list(){  //可选的快币
                let str = this.data.tpl_currency_ids;
                return  str?str.split(",").map(id=>this.$func.queryCurrency(id)):[];
            },  
            tpl_describe(){  //任务类型描述
                return this.data.tpl_description || "暂无";
            },  
            time_range(){  //任务时间 限制
                let str = this.data.tpl_task_range;
                return str?str.split(",").map(str=>parseInt(str)):[];
            },
            bonus_range(){  //任务奖金 限制
                let str = this.data.tpl_currency_range;
                return str?str.split(",").map(str=>parseInt(str)):[];
            },

            // *****任务状态
            status_str(){
                return this.status_obj[this.detailData.process_status];
            },
        },

        watch:{
            detailData(obj){   //通过detailData  确定是否要重置页面
                console.log("变了");
                if(obj.id){
                    this.sub.tempId = this.detailData.template_id;
                    this.sub.buId = this.detailData.sub_bu_id;
                    this.sub.taskName = this.detailData.task_name;
                    this.sub.taskDescribe = this.detailData.task_description;
                    this.sub.taskCycle = this.detailData.task_cycle;
                    // this.sub.currencyId = this.detailData.currency_id;
                    this.sub.fastBonus = this.detailData.currency_amount;

                    this.sub.uploadDoc = [];
                    this.sub.deldocId = [];
                    this.sub.require_doc = this.detailData.task_requirement_doc || [];

                    this.assign_id = this.detailData.assign_user && this.detailData.assign_user.assign_to;

                    this.getKeyData(this.sub.tempId);
                    if(this.execute_judge){
                        this.$func.getBuMembers(true);  
                    }
                }
            },
            hide(){
                if(this.select_flag){
                    this.$refs['select_dom'].handleClose();
                }
            }
        },

        methods:{
            hideChange(show){
                this.select_flag = show;
            },
            linkage(id){  //联动的请求
                this.sub.buId = "";
                // this.sub.currencyId = "";
                this.getKeyData(id);
            },
            getKeyData(id){   //根据任务类型获取 list
                this.$http.get(`api/clerk/task/task_tpl/${id}`).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                }).catch(err=>{
                    this.errorTip("出错啦");
                });
            },

            addUploadFile(event){  //添加上传文件
                this.$form.hideError(this.$refs["box"].$el);  // 去除报错

                let input = event.target;
                // 文件大小检查
                let list = input.files;
                let all = 0;  //文件总大小
                // 文件大小检测
                for(let item of list){
                    let size = item.size/1024;
                    if(size > 10000){ //10M
                        this.errorTip(`单个文件大小不得超过10M`);
                        input.value = "";
                        return;
                    }
                    all+= size;
                };

                if(all > 100000){  //100M
                    this.errorTip(`上传文件总大小不得超过100M`);
                    input.value = "";
                    return;
                }

                // 没毛病的时候
                for (let item of list) {
                    this.sub.uploadDoc.unshift(item);
                }
                input.value = "";

            },
            downloadFile(id){   //下载文件
                this.$http.get(`api/clerk/task/document/${id}`);
            },
            addDeleteId(id,index){   //删除文件
                if(this.sub.require_doc[index].id == id){
                    console.log("en");
                    this.sub.require_doc.splice(index,1);
                }

                let index2 = this.sub.deldocId.indexOf(id);
                if(index2 == -1){
                    this.sub.deldocId.push(id);
                }
            },
            backRefresh(){  //回退刷新
                this.$router.go(-1);
            },

            // ****按钮****
            changeAssign(){  //变更执行人
                let url = "api/clerk/task/assign_to/update";
                this.$http.post(url,{
                    assign_to:this.assign_id,
                    task_detail_id:this.detailData.id,
                })
                .then(res=>{
                    if(res.status == 200){
                        this.$emit("refresh");
                        this.successTip("变更成功")
                    }
                })
            },
        },

    }
</script>

<style lang="less">
    @import "~src/assets/less/var.less";
    .task-info-wrap{
        .detail-form{
            padding-top: 20px;
            overflow: hidden;
            position:relative;
            padding-bottom: 40px;
            width: calc(~"@{screen} - @{front_side_w} - 2*@{front_padd} - 2*30px");
            // width:calc(~"@{screen} - @{front_side_w} - @{front_padd}");

            // border-bottom: 1px dashed @detail_border;

            .left,.right{
                float:left;
            }
            .left{
                width: calc(~"100% - @{detail_right}");
            }
            .right{
                width:@detail_right;
            }
            
            .btns{
                position:absolute;
                bottom:10px;
                left:0;
            }
        }


        @title_w:100px;  //表单 标题长度
        .front-form-item{
            &:after{
                content:"";
                display: block;
                clear:both;
            }
            >div{
                float:left;
            }

            
            // 标题
            .item-title{
                margin-bottom:24px;                
                line-height: 30px;
                text-align: right;
                margin-right: 30px;
                width:@title_w;
                &.must span{
                    position: relative;
                    &:after{
                        content: "";
                        display:block;
                        position: absolute;
                        height: 5px;
                        width:5px;
                        border-radius: 50%;
        
                        left: -10px;
                        top: 50%;
                        transform:translateY(-50%);
                        background: #ff6b6b;
                    }
                }

            }

            // 内容
            .item-wrap{
                margin-bottom:24px;
                font-size:12px;
                // max-width:calc(~"100% - 30px - @{title_w}");
                max-width:360px;
                position: relative;

                .el-textarea__inner{
                    font-size:12px;
                    resize:none;
                    width:340px;
                    height:120px;
                }
                .text{
                    font-weight:600;
                    margin-top:5px;
                    word-break: break-all;
                }

                .tip{
                    position: absolute;
                    top:0;
                    left:calc(~"100% + 15px");
                    font-size:12px;
                    color:#999;
                    line-height: 30px;
                    white-space: nowrap;
                }

            }

        }

        // 表单内的上传 文件
        .doc-wrap{
            // height:100px;
            width:calc(~"100% - 30px - @{title_w}");
            font-size:0;
            .box{
                // width:240px;
                font-size:12px;
                margin-top: 10px;
                height: 100px;
                box-sizing:border-box;
                padding:0 10px;
                border:1px solid #d9d9d9;
                border-radius: 2px;
                // display: inline-block;
                transition:0.3s;
                line-height: 25px;
                .box-item{
                    height:25px;
                    overflow:hidden;
                    :first-child{
                        display: inline-block;
                        margin-right:10px;
                        max-width: calc(~"100% - 60px - 15px");
                    }
                    .red{
                        display: inline-block;
                        vertical-align: top;
                        color:@red;
                        cursor:pointer;
                    }
                    .blue{
                        vertical-align: top;
                        display: inline-block;
                        color:@focus-c;
                        cursor:pointer;
                    }
                }
            }
            .front-btn{
                margin-right:15px;
                vertical-align: bottom;
                position: relative;
                overflow: hidden;
                input{
                    position:absolute;
                    width:100%;
                    height: 100%;
                    top:0;  
                    left:0;
                    opacity:0;
                    cursor:pointer;
                }
            }
        }

        // 下载模板按钮
        .down-doctpl{
            color:@main-c;
            margin-top: 10px;
            display:inline-block;
            cursor:pointer;
            user-select: none;
            &:before{
                content:"";
                display: inline-block;
                height:14px;
                width:20px;
                background:url("~src/assets/image/download.svg") no-repeat;
            }
        }

        // 修正表单样式
        .el-input{
            max-width: 178px;
        }

        // 任务类型说明  细
        .type-text{
            font-weight: 500 !important;
        }

    }
</style>





// WEBPACK FOOTER //
// detail-form.vue?ac600eaa